// This class should be kept up to date with the variables.scss file
// eslint-disable-next-line @typescript-eslint/naming-convention
export enum chartColors {
    /* Default */
    agprBlue = '#3459d4',
    agprPurple = '#ad25f0',
    agprLightBlue = '#0ccbf9',
    agprLighterBlue = '#c1f1fd',
    agprOrange = '#ffa000',
    agprYellow = '#ffd900',
    agprLightGreen = '#b6dc33',
    agprGreen = '#0cb678',
    agprTeal = '#099fa8',
    agprAqua = '#00ffd5',
    agprCoralPink = '#fe7585',
    agprCrimson = '#b70000',
    agprLavender = '#8976db',
    agprMediumBlue = '#007bd8',
    agprDarkPurple = '#a641b2',

    agprBlog = '#791b65',
    agprMagazine = '#e65a92',
    agprOnline = '#a641b2',
    agprPrint = '#c27612',
    agprPressRelease = '#ffa000',
    agprRadio = '#02aeb8',
    agprTelevision = '#1ad6c4',
    agprPodcast = '#197d8c',
    agprFacebook = '#3459d4',
    agprX = '#4b33b6',
    agprReddit = '#ff6726',
    agprYoutube = '#b70000',
    agprInstagram = '#ffd900',
    agprTiktok = '#0ccbf9',
    agprLinkedIn = '#007bd8',
    agprBluesky = '#00FFD5',
    agprPinterest = '#fe7585',
    agprSinaWeibo = '#cc6200',
    agprSnapchat = '#beb702',
    agprTelegram = '#0ccbd9',
    agprThreads = '#0f5792',
    agprTumblr = '#b6dc33',
    agprTwitch = '#8976db',
    agprVK = '#ff866a',
    agprWechat = '#0cb678',
    agprWhatsapp = '#02882f',
    agprOther = '#C7C7C7',

    agprPositive = '#0cbc7b',
    agprNeutral = '#ffb300',
    agprNegative = '#fd3950',
    agprNotAvailable = '#bec6cf',

    agprVolume = '#3459d4',
    agprVolumePrevious = 'rgba(52, 89, 212, 0.1)',
    agprImpressions = '#ad25f0',
    agprImpressionsPrevious = 'rgba(173, 37, 240, 0.1)',
    agprEngagements = '#0ccbf9',
    agprEngagementsPrevious = 'rgba(12, 203, 249, 0.1)',

    agprText = '#2c353e',
    agprInteractive = '#2b4e66',

    agprPositiveGreenDark = '#098558',
    agprPositiveGreenLight = '#c1eddd',
    agprNegativeRedDark = '#b22a3a',
    agprNegativeRedLight = '#fecccc',


    /* Neutrals */

    agprWhite = '#fff',
    agprBlack = '#101010',
    agprGrey = '#444444',
    agprGreyBorder = '#ced4da',
    agprGreyIcon = '#788391',
    agprGreyBackground = '#f9f7fd',
    agprGreyTextPlaceholder = '#5e6473',


    /* white label colors */
    agprWlColor1 = '#005494',
    agprWlColor2 = '#94d1ff',
    agprWlColor3 = '#ff866a',
    agprWlColor4 = '#ff5126',
    agprWlColor5 = '#ffd900',
    agprWlColor6 = '#10682d',
    agprWlColor7 = '#002c50',
    agprWlColor8 = '#bc1d5d',
    agprWlColor9 = '#eg5a92',
    agprWlColor10 = '#58595b',
    agprWlBlog = '#94d1ff',
    agprWlMagazine = '#940075',
    agprWlOnline = '#002c50',
    agprWlPrint = '#005494',
    agprWlPressRelease = '#ffd900',
    agprWlRadio = '#ff5126',
    agprWlTelevision = '#ff866a',
    agprWlPodcast = '#01654e',
    agprWlFacebook = '#02882f',
    agprWlX = '#3cc468',
    agprWlReddit = '#bc1d5d',
    agprWlYoutube = '#e65a92',
    agprWlInstagram = '#beb702',
    agprWlTiktok = '#a27e05',
    agprWlLinkedIn = '#39d2c3',
    agprWlBluesky = '#00FFD5',
    agprWlPinterest = '#ff7e8d',
    agprWlSinaWeibo = '#b96a44',
    agprWlSnapchat = '#007bd8',
    agprWlTelegram = '#940919',
    agprWlThreads = '#00d3ff',
    agprWlTumblr = '#f82d44',
    agprWlTwitch = '#f9903c',
    agprWlVK = '#4b33b6',
    agprWlWechat = '#009fa9',
    agprWlWhatsapp = '#8976db',
    agprWlOther = '#c7c7c7',
    agprWlSocialFacebook = '#005494',
    agprWlSocialX = '#94d1ff',
    agprWlSocialInstagram = '#ffd900',
    agprWlSocialYouTube = '#CE4024',
    agprWlSocialReddit = '#ff5126',
    agprWlSocialTikTok = '#bc1d5d',
    agprWlPositive = '#005494',
    agprWlNeutral = '#94d1ff',
    agprWlNegative = '#ce4024',
    agprWlNotAvailable = '#d7d8d9',
    agprWlVolume = '#005494',
    agprWlVolumePrevious = '#eef8ff',
    agprWlImpressions = '#94d1ff',
    agprWlImpressionsPrevious = '#eef8ff',
    agprWlEngagements = '#ff5126',
    agprWlEngagementsPrevious = 'f4ece9',

    /* OLD */

    agprGrey70 = '#5e6473',
    agprLightGrey = '#e5e5e5', // deprecated
    agprGreyMediumE5 = '#e5e5e5',
    agprLighterGrey = '#f7f7f7',
    agprGreyLightFA = '#fafafa',
    agprGreyLightF3 = '#f3f3f3',
    agprMediumGrey = '#5e6473',
    agprLighterMediumGrey = '#c7c7c7',
    agprDarkerMediumGrey = '#58595b', // deprecated
    agprGreyDark58 = '#58595b',
}
